import Box from '@mui/material/Box'
import Markdown from '../Markdown'
import { bodyText, colours } from '../player/playerStyles'

const Illustration = ({ block, content }) => {
  const src = content?.media?.[block.media]
  return (
    <Box>
      <Box component="figure" sx={{ m: 0 }}>
        {src ? (
          <Box component="img" src={src} alt={block.alt} sx={{ display: 'block', maxWidth: '100%', height: 'auto', borderRadius: 1 }} />
        ) : (
          // The picture could not be loaded: its description stands in.
          <Box sx={{ ...bodyText, p: 2, border: `1px solid ${colours.border}`, borderRadius: 1 }}>{block.alt}</Box>
        )}
        {block.caption && (
          <Box component="figcaption" sx={{ ...bodyText, fontSize: '1rem', color: colours.muted, mt: 1 }}>
            {block.caption}
          </Box>
        )}
      </Box>
      {block.body && <Markdown sx={{ ...bodyText, mt: 2 }}>{block.body}</Markdown>}
    </Box>
  )
}

export default Illustration
